import React from 'react';
import Styled from '../../theme/Styled';
import { CircularProgress } from '@material-ui/core';
const lightShadowColor1 = 'rgba(55, 84, 170, .1)';
const lightShadowColor2 = 'rgba(55, 84, 170, .15)';
const darkShadowColor1 = 'rgba(0, 0, 0, .7)';
/**
 * Img
 */
const ThumbnailImg = Styled.img `
  border-radius: 8px;
  box-shadow: ${(props) => props.theme.mode === 'light'
    ? `-3px -2px 4px ${lightShadowColor1}, 3px 2px 4px ${lightShadowColor2}`
    : `-1px -1px 1px ${darkShadowColor1}, 3px 3px 10px ${darkShadowColor1}`};
`;
const AvatarImg = Styled.img `
  vertical-align: middle;
  border-radius: 50%;
  box-shadow: ${(props) => props.theme.mode === 'light'
    ? `-3px -2px 4px ${lightShadowColor1}, 3px 2px 4px ${lightShadowColor2}`
    : `-1px -1px 1px ${darkShadowColor1}, 3px 3px 10px ${darkShadowColor1}`};
`;
const imgType = {
    thumbnail: 'thumbnail',
    avatar: 'avatar',
};
export const Img = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    // Avatar
    const avatarSize = 60;
    // Thumbnail
    const thumbnailWidth = 200;
    const thumbnailHeight = ((_a = props.img) === null || _a === void 0 ? void 0 : _a.width) && typeof props.img.width === 'number' ? ((_b = props.img) === null || _b === void 0 ? void 0 : _b.width) * (3 / 4) : '100%';
    return (React.createElement(React.Fragment, null, props.type === imgType.avatar ? (React.createElement(AvatarImg, Object.assign({}, props.img, { style: {
            width: ((_c = props.img) === null || _c === void 0 ? void 0 : _c.width) ? props.img.width : avatarSize,
            height: ((_d = props.img) === null || _d === void 0 ? void 0 : _d.height) ? props.img.height : avatarSize,
        }, alt: (_e = props.img) === null || _e === void 0 ? void 0 : _e.alt }))) : (React.createElement(ThumbnailImg, Object.assign({}, props.img, { style: {
            width: ((_f = props.img) === null || _f === void 0 ? void 0 : _f.width) ? props.img.width : thumbnailWidth,
            height: ((_g = props.img) === null || _g === void 0 ? void 0 : _g.height) ? props.img.height : thumbnailHeight,
        }, alt: (_h = props.img) === null || _h === void 0 ? void 0 : _h.alt })))));
};
/**
 * Img for file
 */
const StyledDiv = Styled.div `
  margin: auto;
  display: flex;
  box-shadow: ${(props) => props.theme.mode === 'light'
    ? `-3px -2px 4px ${lightShadowColor1}, 3px 2px 4px ${lightShadowColor2}`
    : `-1px -1px 1px ${darkShadowColor1}, 3px 3px 10px ${darkShadowColor1}`};

  &:hover {
    box-shadow: ${(props) => props.theme.mode === 'light'
    ? // light
        `
        inset 0 0 15px rgba(217, 217, 217, 0),
        inset 0 0 20px rgba(255, 255, 255, 0),
        3px 3px 4px rgba(55, 84, 170, .15),
        -1px -1px 4px rgba(255, 255, 255, 1),
        inset 0px 0px 4px rgba(255, 255, 255, .2)
        `
    : // dark
        `
        inset 0 0 15px rgba(0, 0, 0, 0),
        inset 0 0 20px rgba(76, 78, 90, 0),
        3px 3px 4px rgba(0, 0, 0, .15),
        -1px -1px 4px rgba(76, 78, 90, 1),
        inset 0px 0px 4px rgba(76, 78, 90, .2)
        `};
      transition: .5s;
  }
`;
const StyledLabel = Styled.label `
  display: flex;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;
const StyledI = Styled.i `
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;
const StyledInput = Styled.input `
  display: none;
`;
const onChangeInput = (event, onChange) => {
    console.log('onChangeInput', event.target.files);
    if (event.target.files && event.target.files.length > 0 && onChange) {
        const file = event.target.files[0];
        const fileReader = new FileReader();
        fileReader.onload = () => {
            onChange(file, fileReader.result);
        };
        fileReader.readAsDataURL(file);
    }
};
export const ImgFile = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    // Empty icon
    const emptyIconSize = props.emptyIconSize ? props.emptyIconSize : props.type === imgType.avatar ? 32 : 80;
    const EmptyIcon = props.emptyIcon ? (props.emptyIcon) : (React.createElement(StyledI, { className: "material-icons", style: { fontSize: emptyIconSize } }, props.type !== undefined && props.type === 'avatar' ? 'perm_identity' : 'add_photo_alternate'));
    // Avatar
    const avatarSize = 60;
    // Thumbnail
    const thumbnailWidth = 200;
    const thumbnailHeight = ((_a = props.img) === null || _a === void 0 ? void 0 : _a.width) && typeof props.img.width === 'number' ? ((_b = props.img) === null || _b === void 0 ? void 0 : _b.width) * (3 / 4) : thumbnailWidth * (3 / 4);
    const Image = props.type === imgType.avatar ? (React.createElement(AvatarImg, Object.assign({}, props.img, { style: {
            width: ((_c = props.img) === null || _c === void 0 ? void 0 : _c.width) ? props.img.width : avatarSize,
            height: ((_d = props.img) === null || _d === void 0 ? void 0 : _d.height) ? props.img.height : avatarSize,
        }, alt: (_e = props.img) === null || _e === void 0 ? void 0 : _e.alt }))) : (React.createElement(ThumbnailImg, Object.assign({}, props.img, { style: {
            width: ((_f = props.img) === null || _f === void 0 ? void 0 : _f.width) ? props.img.width : thumbnailWidth,
            height: ((_g = props.img) === null || _g === void 0 ? void 0 : _g.height) ? props.img.height : '100%',
        }, alt: (_h = props.img) === null || _h === void 0 ? void 0 : _h.alt })));
    return (React.createElement(StyledDiv, { style: {
            width: ((_j = props.img) === null || _j === void 0 ? void 0 : _j.width) ? props.img.width : props.type === imgType.avatar ? avatarSize : thumbnailWidth,
            height: ((_k = props.img) === null || _k === void 0 ? void 0 : _k.height) ? props.img.height : props.type === imgType.avatar ? avatarSize : thumbnailHeight,
            borderRadius: props.type === imgType.avatar ? '50%' : 8,
        } }, props.loading !== undefined && props.loading ? (React.createElement(CircularProgress, { style: {
            margin: 'auto',
        } })) : (React.createElement(StyledLabel, null,
        ((_l = props.img) === null || _l === void 0 ? void 0 : _l.src) ? React.createElement(React.Fragment, null, Image) : React.createElement(React.Fragment, null, EmptyIcon),
        React.createElement(StyledInput, { type: "file", onChange: (event) => onChangeInput(event, props.onChange) })))));
};
